import { useAuth } from 'react-oidc-context';
import { t } from 'i18next';
import { Loader } from '../../components/Loader';
import { Button } from '../../components/Button/index';
import styles from './XimiSSOCallback.module.css';

/**
 * Landing route for the Ximi SSO redirect (web/PWA + écran d'attente natif).
 * The AuthProvider processes the authorization code automatically; la navigation
 * vers /home est pilotée par useXimiStimulinSignIn UNE FOIS l'échange Stimul'In
 * terminé (tokens + user chargés) — cette page n'affiche qu'un loader, ou l'erreur SSO.
 */
export function XimiSSOCallback(): JSX.Element {
    const auth = useAuth();

    if (auth.error) {
        return (
            <div className={styles.container}>
                <h3>{t('La connexion Ximi a échoué')}</h3>
                <p>{auth.error.message}</p>
                <Button label={t('Retour à la connexion') ?? ''} action="/login" />
            </div>
        );
    }

    return <Loader />;
}
